import EventManager from "../eventManager.js";
import StringUtils from "../utils/string.js";
import DateUtils from "../utils/date.js";

export default class Product extends EventManager {

  constructor($product, settings) {
    super();
    this.$container = $product
    this.$container.data('product', this)
    this.settings = Object.assign(
        {},
        {
          autoSelect: false,
          debug: false,
          loadUrl: 'core/ajax/ajax_produit.php'
        }
      )
    this._lastContentsHashes = {}
    this.$buyButton.click(() => {
      if (!this.$buyButton.hasClass('disabled')) {
        this.on('add_to_cart')
      }
    })
    this.addListener('data_set', this.onDataSet.bind(this))
  }

  onDataSet(o, data) {
  }

  set data(data) {
    this._data = data
    this.on('data_set', data)
  }
  
  isLoaded() {
    return this._data !== undefined
  }

  cleanContentHtml(html) {
    let $container = $('<div/>').html(html)

    // Clean heights
    $container.find('[height]').removeAttr('height')

    // Clean widths
    $container.find('[width]').removeAttr('width')

    $container.find('iframe')
            .attr('width', 560)
            .attr('height', 349)
            .wrap($('<div/>', {class: 'video'}))
            .wrap($('<div/>', {class: 'videoWrapper'}))

    return $container.html()
  }

  qualifyData(productData) {
    for (let field of ['labels', 'references', 'merchants', 'articles', 'optionTypes', 'options', 'merchants']) {
      if (productData[field] === null) {
        productData[field] = {}
      }
    }
    // Filter contents
    for (let idArt in productData.articles) {
      for (let field of ['description', 'security', 'composition', 'utilisation']) {
        productData.articles[idArt][field] = this.cleanContentHtml(productData.articles[idArt][field])
      }
    }

    if (productData.brand !== null && productData.brand.description !== null) {
      productData.brand.description = this.cleanContentHtml(productData.brand.description)
    }
    return productData
  }

  load() {
    if (this._currentLoadPromise === undefined) {
      let requestParams = {
        idArt: this.$container.data('idart'),
        idRub: this.$container.data('rubid'),
        _format: 'json'
      }

      if (this.$container.data('idartref')) {
        requestParams.idArtRef = this.$container.data('idartref')
      }

      this._currentLoadPromise = new Promise((resolve, reject) => $.get(this.settings.loadUrl, requestParams).done(productData => {
          if (productData.articles === undefined) {
            return reject(productData)
          }
          try {
            this.data = this.qualifyData(productData)
          } catch (error) {
            reject({
              in: 'qualifyData',
              error: { message: error.message, stack: error.stack },
              productData: productData
            })
          }
          resolve(this.data)
        }).fail((jqXHR, textStatus, errorThrown) => {
          reject(errorThrown)
        })
      )
    }
    return this._currentLoadPromise
  }

  get data() {
    return this._data
  }

  get rubId() {
    return this.$container.data('rubid')
  }

  set rubId(id) {
    this.$container.data('rubid', id)
  }

  get idArt() {
    return this.configuredReference !== undefined ? this.configuredReference.idArt : this.$container.data('idart')
  }

  get idArtRef() {
    return this.configuredReference !== undefined ? this.configuredReference.idArtRef : this.$container.data('idartref')
  }

  set idArtRef(idArtRef) {
    this.currentReference = this.data.references[idArtRef]
  }

  get merchantId() {
    return this.configuredReference !== undefined ? this.configuredReference.merchantId : this.$container.data('merchantid')
  }

  get name() {
    return this.data !== undefined && this.configuredReference !== undefined
            ? this.data.articles[this.configuredReference.idArt].title
            : this.$container.data('name')
  }

  get brand() {
    return this.data !== undefined && this.data.brand !== null
            ? this.data.brand.label
            : this.$container.data('brand')
  }

  get category() {
    return this.data !== undefined && this.configuredReference !== undefined
            ? this.data.articles[this.configuredReference.idArt].internalCategory
            : this.$container.data('category')
  }
  
  get adwordId() {
      let sIdArt = ""+this.configuredReference.idArt;
      let sIdArtRef = ""+this.configuredReference.idArtRef;
      let lenIdArt = sIdArt.length;
      let lenIdArtRef = sIdArtRef.length;
      for(let i = 0 ; i < 4-lenIdArt ; i++){
          sIdArt = "0"+sIdArt;
      }
      for(let i = 0 ; i < 4-lenIdArtRef-4 ; i++){
          sIdArt = "0"+sIdArt;
      }
      return sIdArt+"."+sIdArtRef;
  }

  get variant() {
    return this.data !== undefined && this.configuredReference !== undefined
            ? this.configuredReference.options.map(optionId => this.data.options[optionId].label).join(', ')
            : this.$container.data('variant')
  }

  get list_position() {
    return this.$container.data('list_position')
  }

  get quantity() {
    return this.$container.data('merchantid')
  }

  get finalPrice() {
    return this.data !== undefined && this.configuredReference !== undefined && this.configuredReference.price !== null
            ? this.configuredReference.price.final
            : this.$container.data('price')
  }

  get devise() {
    return this.data !== undefined && this.configuredReference !== undefined
            ? this.configuredReference.price.devise
            : 'EUR'
  }

  get configuredReference() {
    return undefined
  }

  set currentReference(reference) {
  }

  // Object general getters and setters
  set quantityInCart(quantity) {
    quantity = parseInt(quantity)
    let $badge = this.$buyButton.find('.badge')
    if (quantity > 0) {
      if ($badge.length === 0) {
        $badge = $('<span/>', {class: 'badge'})
                .appendTo(this.$buyButton)
      }
      $badge.html(quantity)
    } else if ($badge.length > 0) {
      $badge.remove()
    }
  }

  set price(price) {
    this.$priceContainer
            .empty()

    let $finalPriceContainer = $('<div>', {class: 'final'})
            .appendTo(this.$priceContainer)

    $('<span>', {class: 'final'})
            .html(price.final !== null 
              ? StringUtils.toLocaleString(price.final, {style: "currency", currency: price.devise})
              : '')
            .appendTo($finalPriceContainer)

    if (price.volume !== null) {
      $('<p>', {class: 'price-legend'})
              .html(price.volume !== null && price.devise !== null
                ? `${StringUtils.toLocaleString(price.volume, {style: "currency", currency: price.devise})} ${price.unit !== undefined && price.unit !== null ? price.unit : `l'unité`}`
                : '')
              .appendTo($finalPriceContainer)
    }

    if (price.ecotaxe) {
      $('<p>', {class: 'price-legend'})
              .html(`Dont participation écotaxe de ${StringUtils.toLocaleString(price.ecotaxe, {style: "currency", currency: price.devise})}`)
              .appendTo($finalPriceContainer)
    }

    if (price.final !== price.original && price.original !== null || price.offer !== null || price.offerConditions !== null) {
      let $offerContainer = $('<div>', {class: 'offer'})
              .appendTo(this.$priceContainer)

      if (price.final !== price.original && price.original !== null) {
        $('<span>', {class: 'original'})
                .html(StringUtils.toLocaleString(price.original, {style: "currency", currency: price.devise}))
                .appendTo($offerContainer)
      }

      if (price.offer !== null) {
        $('<span>', {class: 'badge'})
                .html(price.offer)
                .appendTo($offerContainer)
      }

      if (price.offerType !== null) {
        this.$offerType.html(price.offerType).show()
      } else {
        this.$offerType.hide()
      }

      let conditions = []
      if (price.offerFrom !== null || price.offerTo !== null) {
        conditions.push(StringUtils.ucFirst(DateUtils.getDateRangeStr(price.offerFrom, price.offerTo)))
      }

      if (price.offerConditions !== null) {
        conditions.push(StringUtils.ucFirst(price.offerConditions))
      }

      $('<p>', {class: 'offer-conditions'})
              .html(conditions.join(' - '))
              .appendTo($offerContainer)
    }

  }

  get price() {
    return this.configuredReference !== undefined
            ? this.configuredReference.price
            : undefined
  }

  set labels(labels) {
    this.$labelsList.find('.label').remove()
    if (this.data.labels !== undefined) {
      this.$labelsList.append(
          labels
            .filter(labelId => this.data.labels[labelId] !== undefined && this.data.labels[labelId].picture !== undefined)
            .map(labelId =>
              $('<li/>', {class: 'label'}).html(
                  $('<img/>', {
                    src: this.data.labels[labelId].picture.medium,
                    title: this.data.labels[labelId].name,
                    alt: this.data.labels[labelId].name
                  })
                )
            )
        )
    }
  }

  set packedQuantity(q) {
    this.$labelsList.find('.quantity').remove()
    this.$labelsList.prepend($('<li/>', {class: 'quantity'}).text(`X${q}`))
  }

  stockRecoverAlert() {
    window.alerte_stock(this.idArtRef)
  }

  set notation(notation) {

    if (notation !== null && notation.count !== 0) {
      window.app.getReviewsManagerInstance().then(
        reviewsManager => {
          this.$productNotationContainer.empty()
          reviewsManager.buildRatingHtml(notation.avg).appendTo(this.$productNotationContainer)
          $('<span>', {class: 'count'})
            .html(`${notation.count} avis`)
            .appendTo(this.$productNotationContainer)
        }
      )
      
    } else {
      this.$productNotationContainer.empty()

      $('<span>', {class: 'count'})
        .html(`Soyez le premier à donner un avis !`)
        .appendTo(this.$productNotationContainer)
    }
  }

  get notation() {
    return this.configuredReference !== undefined
            ? this.configuredReference.notation
            : undefined
  }

  get title() {
    return this.$title.html()
  }

  set title(title) {
    this.$title.empty().html(title)
  }

  get description() {
    return this.$descriptionContent.empty().html()
  }

  updateBodyRow(field, content) {
    if (content === '' || content === null || content === undefined) {
      this[field].empty().parent().slideUp()
      delete this._lastContentsHashes[field]
    } else {
      let contentHash = StringUtils.md5(content)
      
      if (this._lastContentsHashes[field] === undefined || this._lastContentsHashes[field] !== contentHash) {
        this._lastContentsHashes[field] = contentHash
        this[field].empty().html(content).parent().slideDown()
      }
    }
  }

  set description(html) {
    var txt = html.replace("<p>", "<h2 style=\"font-size: 0.9em\">");
    txt = txt.replace("</p>", "</h2>");
    this.updateBodyRow('$descriptionContent', txt);
  }

  set security(html) {
    this.updateBodyRow('$securityContent', html)
  }

  set composition(html) {
    this.updateBodyRow('$compositionContent', html)
  }

  get shortDescription() {
    return this.$shortDescriptionContent.html();
  }

  set shortDescription(html) {
    if (html) {
      this.$shortDescriptionContent.empty().html(`${html}`)
    } else {
      this.$shortDescriptionContent.empty().html(`<p></p>`)
    }
    let $lastTextElement = this.$shortDescriptionContent.find('> p:last')
    if ($lastTextElement.length === 0) {
      $lastTextElement = this.$shortDescriptionContent
    }
    $lastTextElement.append(' ')
    $('<a/>', {class: 'link'}).html('Lire plus')
      .click(event => {
        event.preventDefault()
        $('html, body').animate({
          scrollTop: this.$descriptionContent.offset().top - $(window).height() / 5
        }, {
          duration: 'slow',
          complete: () => this.$descriptionContent.parent().addClass('unfoldered').removeClass('foldered')
        })
      })
      .appendTo($lastTextElement)
  }

  get utilisation() {
    return this.$utilisationContent.html();
  }

  set utilisation(html) {
    this.updateBodyRow('$utilisationContent', html)
  }

  set brand(brand) {
    this.$brandLabel.empty()
    if (brand !== null) {
      let prepend = brand.link !== null && brand.pictures.length
              ? `
          <p class="hidden-when-foldered centered">
            <a href="${brand.link}" class="button white soft-shadow rounded">
              <img src="${brand.pictures[0].small}"/><br/>
              Voir tous les produits
            </a>
          </p>
        `
              : ''

      this.updateBodyRow('$brandContent', `${prepend}${brand.description}`)

      this.$brandLabel.html(
        brand.link === null
          ? brand.label
          : `<a href="${brand.link}">${brand.label}</a>`)

    } else {
      this.updateBodyRow('$brandContent', null)
    }
  }

  get currentPicUrl() {
    return this.$mainPicture.attr("src")
  }

  set pictures(pictures) {
    if (pictures !== null && pictures.length > 0) {
      this.$mainPicture
        .attr("src", pictures[0].medium)
        .attr('alt', '')
        .data('large', pictures[0].large)
    } else {
      this.$mainPicture
        .attr("src", 'images/interface/produit/nopic.jpg')
        .attr('alt', 'Aucun visuel disponible')
    }
  }

  set merchantInfos(merchantId) {
    // Update merchant infos
    if (merchantId === undefined || merchantId === null || !(merchantId in this.data.merchants)) {
      this.$merchantsContent.parent().slideUp()
    } else {
      this.$merchantsContent.parent().slideDown()
      
      let merchant = this.data.merchants[merchantId]

      if (merchant.label !== null
              && merchant.label !== '') {
        if (merchant.link !== null) {
          this.merchantLabel = $('<a/>', {
            href: merchant.link
          }).html(`Vendu et expédié par <span>${merchant.label}</span>`)
        } else {
          this.merchantLabel = `Vendu et expédié par <span>${merchant.label}</span>`
        }
        if (parseInt(merchant.reviewsCount) > 0) {
          window.app.getReviewsManagerInstance().then(
            reviewsManager => {
              if (this.$merchantLabel.find('.rating').length === 0) {
                const $rating = $('<span>', {class: 'rating'}).appendTo(this.$merchantLabel)
                reviewsManager.buildRatingHtml(parseFloat(Math.floor(merchant.reviewsAvg))).appendTo($rating)
                $('<span>', {class: 'count'})
                    .html(`${parseInt(merchant.reviewsCount)}&nbsp;avis`)
                    .appendTo($rating)
              }
            }
          )
        }
      }

      if (merchant.shipping !== null) {
        let merchantArguments =
          (merchant.shipping.lowPrice !== null || merchant.shipping.delay
            ? [`Envoi ${merchant.shipping.lowPrice === null
                ? ''
                : `à partir de ${StringUtils.toLocaleString(merchant.shipping.lowPrice, {style: "currency", currency: merchant.shipping.devise})},`}  ${merchant.shipping.delay !== null
                  ? DateUtils.getDelayRangeStr(merchant.shipping.delay.minDays, merchant.shipping.delay.maxDays)
                  : ''}`
              ]
            : [])
        if (merchant.args !== null) {
          merchantArguments = merchantArguments.concat(merchant.args)
        }

        if (merchant.shipping.offers !== null) {
          merchantArguments = merchantArguments.concat(merchant.shipping.offers)
        }

        this.merchantArguments = merchantArguments
      }
    }
  }

  set merchantArguments(args) {
    this.$merchantInfosList
            .find('li:not(.merchant-label)')
            .remove()

    this.$merchantInfosList
            .append(args.map(arg => $('<li/>').html(arg)))
  }

  set stock(stock) {
    if (stock > 0 && stock <= 5) {
      this.on('limited_stock_view') // TODO : send it at init time
      this.$stockContainer.removeClass('hidden').html(`Plus que ${stock} article${stock > 1 ? 's' : ''} en stock !`)
    } else {
      this.$stockContainer.addClass('hidden')
    }
  }

  set merchantLabel(text) {
    this.$merchantLabel.html(text)
  }

  get merchantLabel() {
    return this.$merchantLabel.html()
  }

  getReferenceToLoadAtStart() {

    if (this.idArtRef === undefined
            || this.idArtRef === ''
            || Object.keys(this.data.references).indexOf(this.idArtRef) === -1) {
      // Find the most appropriate reference to load
      let references = Object.values(this.data.references).filter(ref => ref.stock > 0)
      references = references.length === 0 
        ? Object.values(this.data.references)
        : references

      let merchantIds = references.length > 0
        ? references.map(ref => ref.merchantId)
        : Object.values(this.data.merchants)

      if (merchantIds.length === 0) {
        return references.length > 0 ? references[0].idArtRef : undefined
      }

      // If Bebe au naturel is a valid merchant, use it
      if (merchantIds.indexOf('0') !== -1) {
        references = references.filter(ref => ref.merchantId === '0')
      }

      // find the less expensive ref from selected references
      let filteredReferences = references.filter(reference => reference.state.forSell)
      filteredReferences = filteredReferences.length === 0 
        ? references
        : filteredReferences
      
      filteredReferences = filteredReferences.sort((r1, r2) => r1.price.final - r2.price.final)
      return filteredReferences[0].idArtRef
    } else {
      return this.idArtRef
    }
  }

}
